<template>
  <PapeleriaDeliveriesForm :typeEndPoint="'papeleriaDeliveriesForm'" :dataParams="{}"/>
</template>
<script>
import PapeleriaDeliveriesForm from '@/components/modules/papeleria/deliveries/form'
export default {
  name: 'PapeleriaDeliveriesCreate',
  components: {
    PapeleriaDeliveriesForm
  }
}
</script>



// WEBPACK FOOTER //
// src/views/papeleria/deliveries/create.vue